"use strict";


class UserSignInUp extends HttpRequest {
  #_setStepWrapperHeight;
  #signPhoneForm;
  #signFullNameForm;
  #signVerifyForm;
  #steps;
  #phoneInput;
  #fullNameInput;
  #verifyCodeInput;
  #otpDigits;
  #otpError;
  #otpPhoneNumber;
  #btnPhone;
  #btnName;
  #btnVerify;
  #btnContinue;
  #btnResend;
  #btnChangePhone;
  #countdownElement;
  #duration = 1 * 60 /* 1 minutes	 */;
  #resendTimer = null;
  #isResend = false;
  #isVerifyingOtp = false;
  #redirect = null;
  #otpToken = null;
  constructor() {
    super();
    this.#signPhoneForm = document.querySelector(`#signPhoneForm`);
    this.#signFullNameForm = document.querySelector(`#signFullNameForm`);
    this.#signVerifyForm = document.querySelector(`#signVerifyForm`);
    if (!this.#signPhoneForm) {
      return;
    }

    // Step elements
    this.#steps = {
      phone: this.#signPhoneForm.querySelector("#step-phone"),
      name: this.#signFullNameForm.querySelector("#step-name"),
      verify: this.#signVerifyForm.querySelector("#step-verify"),
      success: this.#signVerifyForm.querySelector("#step-success"),
    };

    // Inputs
    this.#phoneInput = this.#signPhoneForm.querySelector("#phoneInput");
    this.#fullNameInput = this.#signFullNameForm.querySelector("#fullNameInput");
    this.#verifyCodeInput = this.#signVerifyForm.querySelector("#verifyCode");
    this.#otpDigits = Array.from(this.#signVerifyForm.querySelectorAll(".auth-otp__digit"));
    this.#otpError = this.#signVerifyForm.querySelector("#authOtpError");
    this.#otpPhoneNumber = this.#signVerifyForm.querySelector("#authOtpPhoneNum");

    // Buttons
    this.#btnPhone = this.#signPhoneForm.querySelector("#btnPhone");
    this.#btnName = this.#signFullNameForm.querySelector("#btnName");
    this.#btnVerify = this.#signVerifyForm.querySelector("#btnVerify");
    this.#btnContinue = this.#signVerifyForm.querySelector("#btnContinue");
    this.#btnResend = this.#signVerifyForm.querySelector("#btnResend");
    this.#btnChangePhone = this.#signVerifyForm.querySelector("#btnChangePhone");

    // count down
    this.#countdownElement = this.#signVerifyForm.querySelector(".resend-countdown");

    // Attach listeners
    this.#initStepsWrapper();
    this.#validations();
    this.#bindEvents();
  }


  #startResendCountdown() {
    this.#clearResendCountdown();
    this.#btnResend.disabled = true;
    this.#btnResend.classList.add('disabled');
    this.#btnResend.querySelector('.resend-text')?.classList.add('d-none');
    this.#countdownElement.classList.remove('d-none');

    let remainingTime = this.#duration;
    const renderCountdown = () => {
      if (remainingTime <= 0) {
        clearInterval(this.#resendTimer);
        this.#resendTimer = null;
        this.#btnResend.disabled = false;
        this.#btnResend.classList.remove('disabled');
        this.#btnResend.querySelector('.resend-text')?.classList.remove('d-none');
        this.#countdownElement.classList.add('d-none');
        return;
      }

      this.#btnResend.querySelector('.resend-text')?.classList.add('d-none');
      this.#countdownElement.classList.remove('d-none');
      const minutes = Math.floor(remainingTime / 60);
      const seconds = remainingTime % 60;
      this.#countdownElement.querySelector('b').textContent = `${minutes}:${String(seconds).padStart(2, "0")}`;
      remainingTime--;
    };

    renderCountdown();
    this.#resendTimer = setInterval(renderCountdown, 1000);
  }
  
  #clearResendCountdown() {
    if (this.#resendTimer) {
      clearInterval(this.#resendTimer);
      this.#resendTimer = null;
    }
  }
  /**
   * Bind all event listeners
   */
  #bindEvents() {
    this.#handlePhone();
    this.#handleName();
    this.#handleVerify();
    this.#handleOtpDigits();
  
    this.#btnContinue?.addEventListener("click", (e) => {
      e.preventDefault();
      this.#handleContinue();
    });

    this.#btnResend?.addEventListener("click", (e) => {
      e.preventDefault();
      this.#handleResend();
    });

    this.#btnChangePhone?.addEventListener("click", (e) => {
      e.preventDefault();
      this.#handleChangePhone();
    });
  }

  #handleOtpDigits() {
    if (!this.#otpDigits.length) return;

    this.#otpDigits.forEach((input, index) => {
      input.addEventListener("input", (event) => {
        const value = event.target.value.replace(/\D/g, "");
        if (value.length > 1) {
          this.#fillOtp(value, index);
          return;
        }

        event.target.value = value.slice(-1);
        event.target.classList.toggle("filled", !!event.target.value);
        event.target.classList.remove("is-invalid");

        if (event.target.value && index < this.#otpDigits.length - 1) {
          this.#otpDigits[index + 1].focus();
        }

        this.#syncOtp();
      });

      input.addEventListener("keydown", (event) => {
        if (event.key === "Backspace" && !input.value && index > 0) {
          this.#otpDigits[index - 1].focus();
          this.#otpDigits[index - 1].value = "";
          this.#otpDigits[index - 1].classList.remove("filled", "is-invalid");
          this.#syncOtp();
        }
      });

      input.addEventListener("paste", (event) => {
        event.preventDefault();
        const pasted = (event.clipboardData || window.clipboardData).getData("text");
        this.#fillOtp(pasted);
      });

      input.addEventListener("focus", () => input.select());
    });
  }

  #fillOtp(value, startIndex = 0) {
    const digits = value.replace(/\D/g, "").slice(0, this.#otpDigits.length);
    if (!digits) {
      this.#syncOtp();
      return;
    }

    if (digits.length === this.#otpDigits.length) {
      this.#otpDigits.forEach((input, index) => {
        input.value = digits[index] || "";
        input.classList.toggle("filled", !!input.value);
        input.classList.remove("is-invalid");
      });
    } else {
      [...digits].forEach((digit, offset) => {
        const input = this.#otpDigits[startIndex + offset];
        if (!input) return;
        input.value = digit;
        input.classList.add("filled");
        input.classList.remove("is-invalid");
      });
    }

    this.#syncOtp();
    const nextEmpty = this.#otpDigits.find((input) => !input.value);
    (nextEmpty || this.#otpDigits[this.#otpDigits.length - 1])?.focus();
  }

  #syncOtp() {
    const code = this.#otpDigits.map((input) => input.value).join("");
    this.#verifyCodeInput.value = code;

    if (code.length < 6) {
      this.#setVerifyButtonEnabled(false);
      this.#clearOtpError();
      return;
    }

    const isComplete = /^\d{6}$/.test(code);
    this.#setVerifyButtonEnabled(isComplete);
    if (isComplete && !this.#isVerifyingOtp) {
      this.#signVerifyForm.requestSubmit();
    }
  }

  #setVerifyButtonEnabled(enabled) {
    this.#btnVerify.classList.toggle("disabled", !enabled);
    this.#btnVerify.disabled = !enabled;
  }

  #resetOtp(focus = false) {
    this.#otpDigits.forEach((input) => {
      input.value = "";
      input.classList.remove("filled", "is-invalid");
    });
    this.#verifyCodeInput.value = "";
    this.#setVerifyButtonEnabled(false);
    this.#clearOtpError();
    if (focus) {
      this.#otpDigits[0]?.focus();
    }
  }

  #setOtpError(message) {
    if (this.#otpError) {
      this.#otpError.textContent = message;
      this.#otpError.classList.remove("d-none");
      this.#otpError.style.display = "block";
    }
    this.#otpDigits.forEach((input) => input.classList.add("is-invalid"));
  }

  #clearOtpError() {
    if (this.#otpError) {
      this.#otpError.textContent = "";
      this.#otpError.classList.add("d-none");
      this.#otpError.style.display = "";
    }
    this.#otpDigits.forEach((input) => input.classList.remove("is-invalid"));
  }

  #setOtpPhoneNumber() {
    if (!this.#otpPhoneNumber) return;
    this.#otpPhoneNumber.textContent = this.#phoneInput.value.trim() || "";
  }

  /**
   * Step 1 — Phone input
   */
  #handlePhone() {
    this.#signPhoneForm.addEventListener("submit", async (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (!this.#signPhoneForm.checkValidity()) {
        this.#alert("אנא הזן מספר טלפון תקין", 'danger');
        return this.#signPhoneForm.classList.add("was-validated");
      }
      this.#signPhoneForm.classList.remove("was-validated");
      if (!validatePhoneNumber(this.#phoneInput.value)) {
        this.#alert("אנא הזן מספר טלפון תקין", 'danger');
        return;
      }

      ShowLoading(this.#signPhoneForm.querySelector('button[type="submit"]'));
      closeKeyboard(this.#phoneInput);
      try {
        const formData = new FormData(this.#signPhoneForm);
        formData.append("module", "Authentication");
        formData.append("action", "SginInUp");
        const { type, token, data } = await this.FormRequest(formData, "");
        if(!type) {
          throw new Error('התרחשה שגיאה לא צפויה אנא נסו שוב מאוחר יותר')
        }
        this.#otpToken = token || data?.token || null;

        this.#setOtpPhoneNumber();
        this.#resetOtp();

        if(type === 'NEW') {
          this.#alert("משתמש חדש – יש להזין שם מלא");
          setTimeout(() => this.#goToStep("name"), 800);
          return;
        }

        this.#startResendCountdown();
        this.#isResend ? this.#alert("נשלח קוד חדש למספר שלך!") : this.#alert("שולחים קוד אימות...");
        setTimeout(() => {
          this.#goToStep("verify");
          this.#resetOtp(true);
        }, 1000);

      } catch (error) {
        setTimeout(() => {
          focusInput(this.#phoneInput);
        }, 500);
        this.#alert(error?.message || 'התרחשה שגיאה לא צפויה אנא נסו שוב מאוחר יותר', 'danger');
      } finally {
        setTimeout(() => HideLoading(this.#signPhoneForm.querySelector('button[type="submit"]')), 1000);
      }
    });
  }


  /**
   * Step 2 — Full name input
   */

  #handleName() {
    this.#signFullNameForm.addEventListener("submit", async (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (!this.#signFullNameForm.checkValidity()) {
        this.#alert("אנא הזן שם מלא תקין", 'danger');
        return this.#signFullNameForm.classList.add("was-validated");
      }
      this.#signFullNameForm.classList.remove("was-validated");
      const fullName = this.#fullNameInput.value.trim();
      if (!isValidFullName(fullName)) {
        this.#alert("אנא הזן שם מלא תקין", 'danger');
        return;
      }
      ShowLoading(this.#signFullNameForm.querySelector('button[type="submit"]'));
      closeKeyboard(this.#fullNameInput);
      try {
        const formData = new FormData(this.#signFullNameForm);
        formData.append("phone", this.#phoneInput.value.trim());
        formData.append("module", "Authentication");
        formData.append("action", "SginInUp");
        const { type, token, data } = await this.FormRequest(formData, "");
        if (!["NEW", "EXISTS"].includes(type)) {
          throw new Error('התרחשה שגיאה לא צפויה אנא נסו שוב מאוחר יותר');
        }
        this.#otpToken = token || data?.token || null;

        this.#alert("שולחים קוד אימות...");
        this.#startResendCountdown();
        
        setTimeout(() => {
          this.#goToStep("verify");
          this.#resetOtp(true);
        }, 800);
        
      } catch (error) {
        setTimeout(() => {
          focusInput(this.#fullNameInput);
        }, 500);
        this.#alert(error?.message || 'התרחשה שגיאה לא צפויה אנא נסו שוב מאוחר יותר', 'danger');
      } finally {
        setTimeout(() => HideLoading(this.#signFullNameForm.querySelector('button[type="submit"]')), 1000);
      }
    });
  }


  /**
   * Step 3 — Verification code input
   */

  #handleVerify() {
    this.#signVerifyForm.addEventListener("submit", async (event) => {
      event.preventDefault();
      event.stopPropagation();

      if (this.#isVerifyingOtp) {
        return;
      }

      if (!/^\d{6}$/.test(this.#verifyCodeInput.value)) {
        this.#setOtpError("אנא הזן קוד אימות תקין");
        return;
      }

      this.#clearOtpError();
      this.#isVerifyingOtp = true;
      ShowLoading(this.#signVerifyForm.querySelector('button[type="submit"]'));
      closeKeyboard(this.#otpDigits[this.#otpDigits.length - 1] || this.#verifyCodeInput);
      try {
        const formData = new FormData(this.#signVerifyForm);
        formData.append("module", "Authentication");
        formData.append("action", "CheckUserVerificationCode");
        if (this.#otpToken) {
          formData.append("token", this.#otpToken);
        }
        const { token, redirect, admin } = await this.FormRequest(formData,"");
        const fireAuth = await $AuthState.ready();
        const credential = await fireAuth.signInWithCustomToken(token);
        await (credential?.user || fireAuth.currentUser)?.getIdToken(true);
        this.#redirect = redirect;
        this.#alert("הקוד אומת בהצלחה!");
        this.#hideHeperText();
        this.#showAdminButton(admin === 1);
        setTimeout(() => this.#goToStep("success"), 600);
      } catch (error) {
        setTimeout(() => {
          this.#otpDigits[0]?.focus();
        }, 500);
        this.#setOtpError(error?.message || 'התרחשה שגיאה לא צפויה אנא נסו שוב מאוחר יותר');
      } finally {
        this.#isVerifyingOtp = false;
        setTimeout(() => {
          HideLoading(this.#signVerifyForm.querySelector('button[type="submit"]'));
          this.#setVerifyButtonEnabled(/^\d{6}$/.test(this.#verifyCodeInput.value));
        }, 1000);
      }
    });
  }

  /**
   * Step 4 — Success screen
   */
  #handleContinue() {
    this.#alert("ההתחברות הושלמה בהצלחה");

    // Use the getRedirectUrl function to get the redirect URL
    const redirectUrl = getRedirectUrl(this.#redirect ?? '');
    location.href =  redirectUrl;
  }

  /**
   * Resend code simulation
   */
  #handleResend() {
    if (this.#btnResend.disabled || this.#btnResend.classList.contains("disabled")) {
      return;
    }
    this.#isResend = true;
    this.#resetOtp();
    this.#signPhoneForm.querySelector('button[type="submit"]').click();
  }

  #handleChangePhone() {
    this.#isResend = false;
    this.#otpToken = null;
    this.#clearResendCountdown();
    this.#resetOtp();
    this.#btnResend.disabled = true;
    this.#btnResend.classList.add("disabled");
    this.#btnResend.querySelector(".resend-text")?.classList.remove("d-none");
    this.#countdownElement.classList.add("d-none");
    this.#goToStep("phone");
    setTimeout(() => focusInput(this.#phoneInput), 250);
  }

  /**
   * Step switching logic
   * @param {string} step - one of: phone, name, verify, success
   */
  #goToStep(step) {
    Object.keys(this.#steps).forEach((key) => {
      this.#steps[key].classList.toggle("active", key === step);
    });
    if (this.#_setStepWrapperHeight) {
      this.#_setStepWrapperHeight();
    }

    if (step === "success") {
      setTimeout(() => scrollToElement(this.#steps.success, "end"), 500);
    }
    
  }

  #showAdminButton(isAdmin) {
    const successStep = this.#signVerifyForm.querySelector("#step-success");
    const successEyebrow = this.#signVerifyForm.querySelector("#authSuccessEyebrow");
    const successTitle = this.#signVerifyForm.querySelector("#authSuccessTitle");
    const successMessage = this.#signVerifyForm.querySelector("#authSuccessMessage");
    const businessHighlights = this.#signVerifyForm.querySelector("#authBusinessHighlights");
    const continueBtnWrapper = this.#signVerifyForm.querySelector("#continueBtnWrapper");
    const adminPanelBtnWrapper = this.#signVerifyForm.querySelector("#adminPanelBtnWrapper");
    const continueBtn = this.#signVerifyForm.querySelector("#btnContinue");
    const adminBtn = this.#signVerifyForm.querySelector("#adminPanelBtnWrapper a");

    successStep?.classList.toggle("is-business", isAdmin);

    if (isAdmin) {
      if (successEyebrow) successEyebrow.textContent = "ממשק ניהול לעסקים";
      if (successTitle) successTitle.textContent = "העסק שלך מוכן לניהול";
      if (successMessage) {
        successMessage.textContent = "התחברת בהצלחה. מכאן אפשר לצפות באתר העסק או להיכנס לממשק הניהול.";
      }
      businessHighlights?.classList.remove("d-none");

      continueBtnWrapper.className = "col-12 col-md-5";
      adminPanelBtnWrapper.className = "col-12 col-md-7";

      continueBtn.textContent = "צפייה באתר";
      adminBtn.textContent = "כניסה לממשק ניהול";
      return;
    }

    if (successEyebrow) successEyebrow.textContent = "התחברות מאובטחת";
    if (successTitle) successTitle.textContent = "ברוך הבא!";
    if (successMessage) {
      successMessage.textContent = "ההתחברות הושלמה בהצלחה. מעבירים אותך בעוד רגע.";
    }
    businessHighlights?.classList.add("d-none");
    continueBtnWrapper.className = "col-12";
    adminPanelBtnWrapper.className = "col-12 d-none";
    continueBtn.textContent = "המשך לאתר";
    adminBtn.textContent = "כניסה לממשק ניהול";
  }



  #initStepsWrapper() {
    const wrapper = document.querySelector(".step-wrapper");
    if (!wrapper) return;

    const setHeight = () => {
        const active = wrapper.querySelector(".sign-step.active");
        if (active) {
          wrapper.style.height = active.offsetHeight + "px";
        }
    };

    setTimeout(setHeight, 50);

    window.addEventListener("resize", () => {
        setHeight();
    });

    this.#_setStepWrapperHeight = setHeight;
}

  /**
   * Show temporary alert message on screen
   * @param {string} msg - Message to display
   */
  #alert(msg, color = 'primary') {
    let alertBox = document.querySelector(".__global-alert");
    if (!alertBox) {
      alertBox = document.createElement("div");
      alertBox.className = `__global-alert alert alert-${color} position-fixed start-50 translate-middle-x shadow-sm text-center`;
      alertBox.style.zIndex = "9999";
      alertBox.style.minWidth = "260px";
      alertBox.style.top = "20%";
      alertBox.style.transform = "translateX(-50%)";
      alertBox.style.transition = "opacity .3s ease";
      document.body.appendChild(alertBox);
    } else {
      alertBox.className = `__global-alert alert alert-${color} position-fixed start-50 translate-middle-x shadow-sm text-center`;
    }

    alertBox.textContent = msg;

    clearTimeout(alertBox._removeTimer);

    alertBox.style.opacity = "1";

    alertBox._removeTimer = setTimeout(() => {
      alertBox.style.opacity = "0";
      setTimeout(() => alertBox.remove(), 300);
    }, 2200);
  }


  #validations() {
    const phoneInput = this.#signPhoneForm.querySelector("#phoneInput");
    const fullNameInput = this.#signFullNameForm.querySelector("#fullNameInput");

    validatePhoneNumberInput(phoneInput);
    validateFullNameInput(fullNameInput);
    this.#setVerifyButtonEnabled(false);

    if (validatePhoneNum(phoneInput?.value)) {
      this.#btnPhone.classList.remove("disabled");
    } else {
      this.#btnPhone.classList.add("disabled");
    }
    phoneInput.addEventListener('input', (e)=> {
      const value = e?.target?.value?.trim();
      if (validatePhoneNum(value)) {
        this.#btnPhone.classList.remove("disabled");
        this.#btnPhone.click();
      } else {
        this.#btnPhone.classList.add("disabled");
      }
    });

    fullNameInput.addEventListener('input', (e)=> {
      const value = e?.target?.value?.trim();
      if (isValidFullName(value)) {
        this.#btnName.classList.remove("disabled");
      } else {
        this.#btnName.classList.add("disabled");
      }
    })
  

  }

  #hideHeperText() {
    const text = document.querySelector('.heper-text');
    if(text) {
      text.classList.add('d-none');
    }
  }

}

// Initialize when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  new UserSignInUp();
});
